import serum from 'assets/images/hairDensityLP/densityLP-serum-desktop.jpg';
import supplements from 'assets/images/productPages/prose-model-holding-custom-root-source-hair-supplements.jpg';

export const densityLPStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 'Custom Hair Supplements',
          image: supplements.src,
          description:
            'Stimulate hair growth with Prose Custom Root Source® Hair Supplements made with natural, clean ingredients. Shop today for longer, stronger hair in 90 days.',
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '32.00',
            highPrice: '64.00',
            priceCurrency: 'USD',
            offers: [
              {
                '@type': 'Offer',
                price: '64.00',
                priceCurrency: 'USD',
                availability: 'https://schema.org/InStock',
                url: 'https://prose.com/products/custom-hair-supplements',
                itemCondition: 'https://schema.org/NewCondition',
                eligibleQuantity: {
                  '@type': 'QuantitativeValue',
                  value: 1,
                },
                shippingDetails: {
                  '@type': 'OfferShippingDetails',
                  shippingRate: {
                    '@type': 'MonetaryAmount',
                    value: '6.95',
                    currency: 'USD',
                  },
                  shippingLabel: 'Standard Shipping (Non-Subscription)',
                },
              },
              {
                '@type': 'Offer',
                price: '32.00',
                priceCurrency: 'USD',
                availability: 'https://schema.org/InStock',
                url: 'https://prose.com/products/custom-hair-supplements',
                itemCondition: 'https://schema.org/NewCondition',
                eligibleQuantity: {
                  '@type': 'QuantitativeValue',
                  value: 1,
                },
                shippingDetails: {
                  '@type': 'OfferShippingDetails',
                  shippingRate: {
                    '@type': 'MonetaryAmount',
                    value: '0.00',
                    currency: 'USD',
                  },
                  shippingLabel: 'Free Shipping (Subscription)',
                  shippingDestination: {
                    '@type': 'DefinedRegion',
                    addressCountry: 'US',
                  },
                },
                hasMerchantReturnPolicy: {
                  '@type': 'MerchantReturnPolicy',
                  url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
                  returnFees: 'https://schema.org/FreeReturn',
                },
              },
            ],
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: 'Custom Scalp Serum',
          image: serum.src,
          description:
            'Shop Prose Custom Scalp Serum — a 99% natural formula to nourish your scalp and boost hair fullness and density. Always made to order. Always just for you.',
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '28.00',
            highPrice: '56.00',
            priceCurrency: 'USD',
            offers: [
              {
                '@type': 'Offer',
                price: '28.00',
                priceCurrency: 'USD',
                availability: 'https://schema.org/InStock',
                url: 'https://prose.com/products/custom-scalp-serum',
                itemCondition: 'https://schema.org/NewCondition',
                eligibleQuantity: {
                  '@type': 'QuantitativeValue',
                  value: 1,
                },
                shippingDetails: {
                  '@type': 'OfferShippingDetails',
                  shippingRate: {
                    '@type': 'MonetaryAmount',
                    value: '6.95',
                    currency: 'USD',
                  },
                  shippingLabel: 'Standard Shipping (Non-Subscription)',
                },
              },
              {
                '@type': 'Offer',
                price: '40.00',
                priceCurrency: 'USD',
                availability: 'https://schema.org/InStock',
                url: 'https://prose.com/products/custom-scalp-serum',
                itemCondition: 'https://schema.org/NewCondition',
                eligibleQuantity: {
                  '@type': 'QuantitativeValue',
                  value: 1,
                },
                shippingDetails: {
                  '@type': 'OfferShippingDetails',
                  shippingRate: {
                    '@type': 'MonetaryAmount',
                    value: '0.00',
                    currency: 'USD',
                  },
                  shippingLabel: 'Free Shipping (Subscription)',
                  shippingDestination: {
                    '@type': 'DefinedRegion',
                    addressCountry: 'US',
                  },
                },
                hasMerchantReturnPolicy: {
                  '@type': 'MerchantReturnPolicy',
                  url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
                  returnFees: 'https://schema.org/FreeReturn',
                },
              },
            ],
          },
        },
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is the difference between the Custom Scalp Serum and Custom Root Source® Hair Supplements and how do they work together?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Simply put, Root Source® Hair Supplements promote hair growth from the inside-out, while Custom Scalp Serum nourishes hair and scalp health from the outside-in. When paired together and used consistently, the benefits compound over time. Designed for daily application, Prose Custom Scalp Serum treats at the root, offering continuous support for the scalp, helping to maintain hydration, soothe irritation, and promote fuller, thicker hair. As a leave-on product, it remains on the scalp throughout the day or night, allowing its clinically tested ingredients to penetrate deeply and work consistently.',
        },
      },
      {
        '@type': 'Question',
        name: 'How soon will I see results using both?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'This will vary for each individual, but those with sensitivities can expect to experience immediate soothing. Within a few weeks of use, your scalp should feel more balanced and hair should start feeling softer. After a month, you can expect a healthier scalp, stronger hair, and the beginnings of hair that looks and feels fuller, denser, and more voluminous. After three months of use, you may notice new baby hairs forming; stay committed, and after six months you’ll continue to see the results of new hair growth.* Results may vary.',
        },
      },
      {
        '@type': 'Question',
        name: 'How should I take my Custom Root Source® Supplements?How should I take my Custom Root Source® Supplements?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Take one capsule from each Root Source® jar daily, with water (and food if you have a sensitive stomach). Consistency is key, so aim to take daily without skipping any doses. If your capsules look a little cloudy it’s completely normal. Root Source® is made without any synthetic fillers or dyes, so what you’re seeing is natural. The actives may separate into their crystalline forms, making spots of the capsule appear cloudy, but this has no impact on the formulas’ freshness or potency.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do these products help to achieve fuller, denser hair?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes — the Custom Hair Density Set is designed as a simple, 2-step system to promote scalp care and hair health, fullness, and density from inside and out. Powerful alone and transformative together, each formula in the set is personalized to meet your specific needs, with targeted ingredients to help common concerns such as dry scalp, hair loss, flakiness, itchiness, and more.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long will each bottle last?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Every order of Custom Root Source® Hair Supplements contains a 30-day supply of 2 capsules (60 capsules total). Your first order will arrive in sustainable glass jars with your name on them. After that, we’ll send your custom hair supplements in pouches made of 100% compostable materials, so you can reuse your original bottles with every order. When applied daily as directed, your Custom Scalp Serum bottle is designed to last 1 month. To help minimize waste, we recommend reusing your dropper with your subsequent orders.',
        },
      },
      {
        '@type': 'Question',
        name: 'Will the Custom Hair Density Set meet my Prose ingredient preferences? What if I have an ingredient concern?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'All Root Source® and Custom Scalp Serum formulas are vegan, GMO-free, and 99% natural as standard. Root Source® are gluten-free through the use of gluten-free wheat extract and also free from: soy, nuts, hormone disruptors, drug ingredients, synthetic fillers, artificial flavors, and artificial coloring. You can view a full list of your ingredients in your shopping cart before checkout, but please note that we cannot add or remove ingredients from your supplement formulas. If you are pregnant, nursing, have a health condition or are taking medication, please consult with your doctor before taking Root Source®. If you have any specific ingredient or allergy concerns, please send us a note via our contact form here.',
        },
      },
      {
        '@type': 'Question',
        name: 'Will the Custom Hair Density Set work for my specific hair type and texture?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes — like all Prose hair and skin formulas, your Custom Hair Density Set will be personalized to 85+ factors from your in-depth consultation and will work on straight (type 1), wavy (type 2), curly (type 3) and coily (type 4) hair. We account for everything from your hair density, porosity, and texture to what you eat and the weather and water where you live, so your hair can get the exact care that it needs.  We also ensure our products are tested on a full range of hair types, including type 3 and type 4 — hair types often overlooked by traditional mass-produced beauty brands.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long will each bottle last?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Every order of Custom Root Source® Hair Supplements contains a 30-day supply of 2 capsules (60 capsules total). Your first order will arrive in sustainable glass jars with your name on them. After that, we’ll send your custom hair supplements in pouches made of 100% compostable materials, so you can reuse your original bottles with every order.   When applied daily as directed, your Custom Scalp Serum bottle is designed to last 1 month. To help minimize waste, we recommend reusing your dropper with your subsequent orders.',
        },
      },
      {
        '@type': 'Question',
        name: 'Will the two products in the Custom Hair Density Set ship together?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Your first order of Custom Scalp Serum and Hair Supplements will ship together. Subsequent subscription orders will ship on slightly different cadences: Hair Supplements ship every 25 days to ensure you never miss a dose. Scalp Serum ships every 4, 8, or 12 weeks, based on your selected frequency.',
        },
      },
    ],
  },
];
